import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const CheckmarkIcon = ({size = SIZE.STANDARD, color = '#7CD99F', onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.STANDARD:
				return '12';
			default:
				return '12';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.STANDARD:
				return '10';
			default:
				return '10';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg
				width={getWidth(size)}
				height={getHeight(size)}
				viewBox="0 0 12 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M1 6.40971L4.46144 9L11 1"
					stroke={color}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</StyledSpan>
	);
};

CheckmarkIcon.SIZE = SIZE;
CheckmarkIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

export const StyledSpan = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
